import QuoteCard from './components/QuoteCard';


function App(props) {
  
  // return
  return (
   <div>
      <QuoteCard />
   </div> 
  )
}


export default App;
